import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
// import { OtpMetaModel, OtpModel } from "common/models/page-models/otp-model";
import { SystemService } from "common/services/core-services/system.service";
import { API_URL, USER_TYPE } from "common/constants/sm-constants";
import { SmMetaModel } from "common/models/utility-models/meta-model";
import { environment } from 'src/environments/environment';
import { OtpModel } from "common/models/page-models/Login/Otp/otp-data-model";
import { OtpMetaModel } from "common/models/page-models/Login/Otp/otp-form-meta-model";
import { OtpFormDataService } from "common/services/data-services/admin/login/otp/otp-form-data-service";

@Injectable({
    providedIn: 'root'
})
export class OtpFormWidgetService extends FormWidgetService<OtpModel> {
    
    router: any;
    constructor(protected ds: OtpFormDataService, private ss: SystemService) {
        super(ds);
    }

    

    // override processFormModel(model: any, meta: any, data: any): Promise<any> {
    //     return new Promise<any>((resolve, reject) => {
    //         this.formDataService
    //             .submitModel(model, meta, data)
    //             .then(res => {
    //                 resolve(res);
    //             })
    //             .catch(err => {
    //                 reject(err);
    //             });
    //     });
    // }


    getMetaModel(): MetaModel {
        const meta = new OtpMetaModel();
        return meta.getMetaModel();
    }

    override prepareMetaModel(dataModel: DataModel, metaModel: OtpMetaModel, routeData: WidgetModel): Promise<OtpMetaModel> {
        
        return new Promise<OtpMetaModel>((resolve, reject) => {
            resolve(metaModel);
           
        });
    }

    // otp(body, widget) {
    //     const payload = {
    //         otp: body.otp,
    //         email: widget.email
    //     }
    //     this.ds.otp(payload).then(response => {
    //         if (response) {
    //             this.ss.setLoginData(response);
    //             switch(this.ss.getUserRole()) {
    //                 case USER_TYPE.student:
    //                     break;
    //                 case USER_TYPE.admin:
    //                     this.ss.navigateToDashboard();
    //                     break;
    //             }
    //             // if (this.ss.getUserRole() === USER_TYPE.student) {
    //             // } else if (this.ss.getUserRole() === USER_TYPE.admin) {
    //             //     this.ss.navigateToDashboard();
    //             // } else {
    //             //     this.ss.router.navigate(['/'])                // redirect to profile
    //             // }
    //         } else {
    //             this.ss.showError('something went wrong, please try again!')
    //         }
    //     });
    // }

   

    regenerateOtp(body) {
        this.ds.postDataToCustomEndPoint(body, null, environment.apiUrl + API_URL.login).then((data) => {
            
            this.ss.showSuccess(data['header'].msg)
        })
    } 
    
  
}
